module.exports = __webpack_public_path__ + "static/img/score_4.04e9d07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/score/score_4.jpg
// module id = Yerv
// module chunks = 0